import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import Test from './Test';
import { TestVoice } from './TestVoice';

class TestSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/test-and-deploy/Test";
            var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/Test/";
            if (currentPath === path || currentPath === path1) {
                $("#test-agent-tab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/test-and-deploy/Test/voice')) {
                $("#test-voice-tab").addClass('active');
            } $("#test-agent-tab,#test-voice-tab")
                .on("click", function () {
                    $("#test-agent-tab,#test-voice-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-test-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })

            $("#test-agent-tab").on("click", function () {
                $("#parse-output,#faq-extr,#intent-extr,#slot-extr,#matching-score")
                    .removeClass('active');
                $("#parse-output").addClass('active');
            })

            $("#test-voice-tab").on("click", function () {
                $("#test-transcript,#test-parse-output,#test-faq-extr,#test-intent-extr,#test-slot-extr,#test-matching-score")
                    .removeClass('active');
                $("#test-transcript").addClass('active');
            })
        })();
    }
    render() {
        return (
            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '10px' }}>
                            <ul className="nav nav-tabs border-bottom navCluster">
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/Test" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="test-agent-tab">
                                        Agent
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/test-and-deploy/Test/voice" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="test-voice-tab" >
                                        Voice
                                    </li></Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/test-and-deploy/Test/voice" component={TestVoice}></Route>
                    <Route path="/projectmgmt/test-and-deploy/Test" component={Test}></Route>
                </Switch>
            </div>

        );
    }
}
export default TestSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/TestSetting.js